import React from "react";
import { Fullpage, HorizontalSlider, Slide } from "fullpage-react";
import ReactAudioPlayer from "react-audio-player";
import BGAudio from "../public/bg.ogg";

const { changeHorizontalSlide, changeFullpageSlide } = Fullpage;

require("normalize-css");
require("./styles/skeleton.css");
require("./styles/main.styl");

const fullPageOptions = {
  scrollSensitivity: 7,
  touchSensitivity: -3,
  scrollSpeed: 500,
  resetSlides: true,
  hideScrollBars: true,
  enableArrowKeys: true,
};

const horizontalNavStyle = {
  position: "absolute",
  width: "100%",
  top: "50%",
  zIndex: 10,
};

class FullpageReact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: {
        Fullpage: 0,
        horizontalSlider1: 0,
      },
    };

    this.onSlideChangeStart = this.onSlideChangeStart.bind(this);
    this.onSlideChangeEnd = this.onSlideChangeEnd.bind(this);
  }

  onSlideChangeStart(name, props, state, newState) {
    if (!this.horizontalNav) {
      this.horizontalNav = document.getElementById("horizontal-nav");
    }

    if (name === "horizontalSlider1") {
      scrollNavStart(this.horizontalNav);
    }
  }

  onSlideChangeEnd(name, props, state, newState) {
    if (name === "horizontalSlider1") {
      scrollNavEnd(this.horizontalNav);
    }

    const oldActive = this.state.active;
    const sliderState = {
      [name]: newState.activeSlide,
    };

    const updatedState = Object.assign(oldActive, sliderState);
    this.setState(updatedState);
  }

  componentDidMount() {}

  render() {
    const horizontalNav = (prevHorizontalSlide, nextHorizontalSlide) => (
      <div id="horizontal-nav" className="slide" style={horizontalNavStyle}>
        <button
          style={{
            position: "absolute",
            background: "none",
            fontSize: 20,
            left: "0px",
            color: "white",
            opacity: "50%",
            border: "0px",
          }}
          onClick={prevHorizontalSlide}
        >
          Prev
        </button>
        <button
          style={{
            position: "absolute",
            background: "none",
            fontSize: 20,
            right: "0px",
            color: "white",
            opacity: "50%",
            border: "0px",
          }}
          onClick={nextHorizontalSlide}
        >
          Next
        </button>
      </div>
    );

    const verticalSlides = [
      <Slide className="slide bg1-b">
        <div id="title">Hai orang tersayang..</div>
      </Slide>,
      <Slide className="slide bg2-b">
        <div id="title">
          Tidak terasa sudah berjumpa dengan 28 Februari kembali
        </div>
      </Slide>,
      <Slide className="slide bg3-b">
        <div id="title">
          Hari ini ada seseorang yang ingin aku perkenalkan kepadamu
        </div>
      </Slide>,
      <Slide className="slide bg4-b">
        <div id="title">Tentang seseorang yang mengagumimu</div>
      </Slide>,
      <Slide className="slide bg5-b">
        <div id="title">
          Aku ingin bercerita sedikit tentang kisahnya menemukanmu
        </div>
      </Slide>,
      <HorizontalSlider
        id="horizontal-slider-1"
        className="slide "
        name="horizontal-slider-1"
        infinite={true}
        slides={[
          <Slide className="bg6-b">
            <div className="sub-title">
              5 Januari 2020
              <br />~ When we first met ~
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Hari pertamanya bekerja di sebuah startup kecil di kotanya
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Tidak ada yang spesial dari startup itu
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Kecuali satu..</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Kamu yang duduk tepat di belakangnya
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Dengan baju cream, dan hijab corakmu
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Kamu terlihat sangat friendly dengan teman-temannya yang sudah
              lebih dulu join di startup itu
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Ada magnet tersendiri padamu</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Caramu berbicara</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Caramu menatap lawan bicara ketika bercengkrama
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Caramu mengatur timmu</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Caramu memberi perhatian kepada teman se-timmu
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Tanpa sadar dia terpikat denganmu</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Masa-masa selama dia bekerja denganmu
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Dia semakin mengenalmu</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Betapa perhatian kamu dengan orang lain
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Terkadang dia cemburu, menggerutu kenapa tidak bisa semua
              perhatianmu untuknya saja
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Namun dia rasa sudah cukup perhatian yang kamu berikan, untuknya
              yang bukan siapa-siapa
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Kamu sudah menjadi tempat bercerita yang nyaman baginya
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Berada di dekatmu saja rasanya sudah cukup baginya
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Biarkan rasa ini miliknya saja, pikirnya
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">Tak terasa 7 bulan berlalu</div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              Dia memutuskan untuk berhenti bekerja untuk fokus dengan studinya
            </div>
          </Slide>,
          <Slide className="bg6-b">
            <div className="sub-title">
              <b>Maka kamu dan dia berpisah pada hari itu</b>
            </div>
          </Slide>,
        ]}
      >
        {horizontalNav(
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-1",
            this.state.active["horizontal-slider-1"] - 1
          ),
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-1",
            this.state.active["horizontal-slider-1"] + 1
          )
        )}
      </HorizontalSlider>,
      <HorizontalSlider
        id="horizontal-slider-2"
        className="slide "
        name="horizontal-slider-2"
        infinite={true}
        slides={[
          <Slide className="bg7-b">
            <div className="sub-title">
              26 Juni 2023
              <br />~ Fateful reunion ~
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">Hampir 2 tahun berlalu begitu saja</div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Kamu dan dia menjalani jalan hidup masing masing
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Hanya beberapa kali saling sapa melalui media sosial
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Dan beberapa kali mengucapkan selamat ulang tahun
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Sisanya dia tidak tahu apa yang kamu lalui
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Dan kamu juga tidak tahu apa yang dia lalui
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Tapi entah kenapa dan siapa yang menggerakkan kamu untuk mengajak
              dia bertemu kembali
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Di cafe itu, di jalan yang sangat familiar
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Dua minuman coklat hangat, dan satu pancake yang kamu dan dia
              makan bersama
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Seakan memori bersama yang telah terlupa datang kembali
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Perasaannya padamu yang sudah lama ia pendam seakan tumbuh kembali
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Hampir 3 jam yang terasa sangat cepat
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Ingin rasanya dia untuk lebih berlama lama lagi bersamamu
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Tapi tidak bisa dipaksakan juga karena dia bukan siapa siapa
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              Kamu dan dia juga masih harus melanjutkan hidup di hari itu
            </div>
          </Slide>,
          <Slide className="bg7-b">
            <div className="sub-title">
              <b>Maka kamu dan dia berpisah pada hari itu</b>
            </div>
          </Slide>,
        ]}
      >
        {horizontalNav(
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-2",
            this.state.active["horizontal-slider-2"] - 1
          ),
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-2",
            this.state.active["horizontal-slider-2"] + 1
          )
        )}
      </HorizontalSlider>,
      <HorizontalSlider
        id="horizontal-slider-3"
        className="slide "
        name="horizontal-slider-3"
        infinite={true}
        slides={[
          <Slide className="bg8-b">
            <div className="sub-title">
              13 Agustus 2023
              <br />~ Getting closer ~
            </div>
          </Slide>,
          <Slide className="bg9-b">
            <div className="sub-title">
              Berawal dari kamu yang menanyakan kabar tentang lamaran
              pekerjaannya
            </div>
          </Slide>,
          <Slide className="bg10-b">
            <div className="sub-title">
              Pekerjaan yang dia dapatkan juga dengan bantuan rekomendasimu
            </div>
          </Slide>,
          <Slide className="bg12-b">
            <div className="sub-title">
              Dia sangat menanti-nanti hari bertemu denganmu
            </div>
          </Slide>,
          <Slide className="bg13-b">
            <div className="sub-title">Di pagi itu..</div>
          </Slide>,
          <Slide className="bg14-b">
            <div className="sub-title">
              Tiba tiba kamu memberi tahu pagi itu bahwa tak bisa berlama hari
              itu
            </div>
          </Slide>,
          <Slide className="bg15-b">
            <div className="sub-title">
              Ada acara pernikahan teman yang harus kamu hadiri
            </div>
          </Slide>,
          <Slide className="bg16-b">
            <div className="sub-title">
              Betapa sedih perasaannya pada waktu itu
            </div>
          </Slide>,
          <Slide className="bg17-b">
            <div className="sub-title">
              Pertemuan yang sudah dirindukannya tidak bisa berlangsung lama
            </div>
          </Slide>,
          <Slide className="bg18-b">
            <div className="sub-title">Tapi tak apa pikirnya</div>
          </Slide>,
          <Slide className="bg1-b">
            <div className="sub-title">
              Dia bukan siapa siapamu, dia bukan prioritasmu
            </div>
          </Slide>,
          <Slide className="bg19-b">
            <div className="sub-title">Pagi itu dia menjemputmu</div>
          </Slide>,
          <Slide className="bg20-b">
            <div className="sub-title">
              Dia membawamu ke sebuah cafe yang dia juga belum pernah
              mendatanginya
            </div>
          </Slide>,
          <Slide className="bg21-b">
            <div className="sub-title">Tanpa disangka cafe itu cukup sepi</div>
          </Slide>,
          <Slide className="bg22-b">
            <div className="sub-title">
              Sehingga kamu dan dia banyak bercerita tentang hidup masing masing
            </div>
          </Slide>,
          <Slide className="bg23-b">
            <div className="sub-title">Rasanya padamu semakin tumbuh</div>
          </Slide>,
          <Slide className="bg24-b">
            <div className="sub-title">
              Entah takdir Tuhan apakah memang seindah itu
            </div>
          </Slide>,
          <Slide className="bg25-b">
            <div className="sub-title">
              Tiba tiba kamu tidak jadi datang ke acara pernikahan temanmu
            </div>
          </Slide>,
          <Slide className="bg26-b">
            <div className="sub-title">Dia pikir ini pertanda</div>
          </Slide>,
          <Slide className="bg27-b">
            <div className="sub-title">
              Dia yang tidak tahu kapan lagi bisa bertemu denganmu
            </div>
          </Slide>,
          <Slide className="bg28-b">
            <div className="sub-title">
              Sehingga dia yang biasanya pasif hari itu memberanikan diri
            </div>
          </Slide>,
          <Slide className="bg29-b">
            <div className="sub-title">
              Mengajakmu ke pameran seni yang sempat kamu singgung di pagi hari
              saat di jalan menuju cafe
            </div>
          </Slide>,
          <Slide className="bg30-b">
            <div className="sub-title">Dan ternyata kamu mengiyakan!</div>
          </Slide>,
          <Slide className="bg31-b">
            <div className="sub-title">Betapa senang hatinya</div>
          </Slide>,
          <Slide className="bg32-b">
            <div className="sub-title">
              Gugup rasanya, karena ini pertama kalinya setelah lama sekali dia
              tidak pergi bersama perempuan
            </div>
          </Slide>,
          <Slide className="bg33-b">
            <div className="sub-title">
              Namun karena kehangatanmu, kegugupannya menghilang
            </div>
          </Slide>,
          <Slide className="bg34-b">
            <div className="sub-title">
              Tersisa perasaan senang dan memori indah yang membekas di hatinya
            </div>
          </Slide>,
          <Slide className="bg35-b">
            <div className="sub-title">
              Benar benar hari paling indah baginya
            </div>
          </Slide>,
          <Slide className="bg36-b">
            <div className="sub-title">Namun lagi lagi</div>
          </Slide>,
          <Slide className="bg37-b">
            <div className="sub-title">Tidak bisa berlama lama denganmu</div>
          </Slide>,
          <Slide className="bg38-b">
            <div className="sub-title">
              Karena ada acara lain yang harus kamu datangi
            </div>
          </Slide>,
          <Slide className="bg39-b">
            <div className="sub-title">
              <b>Maka kamu dan dia berpisah pada hari itu</b>
            </div>
          </Slide>,
        ]}
      >
        {horizontalNav(
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-3",
            this.state.active["horizontal-slider-3"] - 1
          ),
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-3",
            this.state.active["horizontal-slider-3"] + 1
          )
        )}
      </HorizontalSlider>,
      <HorizontalSlider
        id="horizontal-slider-4"
        className="slide "
        name="horizontal-slider-4"
        infinite={true}
        slides={[
          <Slide className="bg40-b">
            <div className="sub-title">
              4 September 2023
              <br />~ Become together ~
            </div>
          </Slide>,
          <Slide className="bg41-b">
            <div className="sub-title">
              Sejak pertemuan terakhir kamu dan dia
            </div>
          </Slide>,
          <Slide className="bg42-b">
            <div className="sub-title">Kamu dan dia semakin dekat</div>
          </Slide>,
          <Slide className="bg43-b">
            <div className="sub-title">
              Saling bercerita tentang kehidupan masing masing hampir setiap
              malam
            </div>
          </Slide>,
          <Slide className="bg44-b">
            <div className="sub-title">
              Kamu dan dia saling bercerita tentang senang dan susah hidup
              masing masing
            </div>
          </Slide>,
          <Slide className="bg45-b">
            <div className="sub-title">
              Semakin dalam lagi mengenal satu sama lain
            </div>
          </Slide>,
          <Slide className="bg46-b">
            <div className="sub-title">
              Hingga akhirnya dia memberanikan diri untuk mengungkapkan
              perasaannya padamu
            </div>
          </Slide>,
          <Slide className="bg47-b">
            <div className="sub-title">
              Tanpa pikir panjang dia membeli tiket pulang kembali ke Jogja 3
              hari sebelum hari bertemu denganmu
            </div>
          </Slide>,
          <Slide className="bg48-b">
            <div className="sub-title">
              Malam hari sebelum bertemu denganmu keesokan harinya
            </div>
          </Slide>,
          <Slide className="bg49-b">
            <div className="sub-title">
              Dia berkeliling kota Jogja untuk mencari toko bunga yang masih
              buka
            </div>
          </Slide>,
          <Slide className="bg50-b">
            <div className="sub-title">
              Dan beruntungnya ada satu toko bunga yang masih buka
            </div>
          </Slide>,
          <Slide className="bg51-b">
            <div className="sub-title">
              Tanpa pikir panjang dia membeli bunga yang hanya tinggal tersisa
              satu jenis saja waktu itu
            </div>
          </Slide>,
          <Slide className="bg52-b">
            <div className="sub-title">
              Keesokan harinya di pagi yang sangat dingin dia menjemputmu
            </div>
          </Slide>,
          <Slide className="bg53-b">
            <div className="sub-title">
              Perjalanan menuju tempat yang dia janjikan padamu lumayan panjang
            </div>
          </Slide>,
          <Slide className="bg54-b">
            <div className="sub-title">
              Udara dingin membuat seluruh tubuhnya gemetar
            </div>
          </Slide>,
          <Slide className="bg55-b">
            <div className="sub-title">
              Namun sesampainya disana seakan semua rasa dingin itu hilang
            </div>
          </Slide>,
          <Slide className="bg56-b">
            <div className="sub-title">
              Sentuhan tanganmu menghangatkan jiwa dan raganya
            </div>
          </Slide>,
          <Slide className="bg57-b">
            <div className="sub-title">
              Setelah dingin menghilang, walau dengan canggung dia beranikan
              diri mengungkapkan rasanya padamu
            </div>
          </Slide>,
          <Slide className="bg58-b">
            <div className="sub-title">Dengan seikat bunga di tangannya</div>
          </Slide>,
          <Slide className="bg59-b">
            <div className="sub-title">
              Dan tanpa dia sangka, kamu menerima!
            </div>
          </Slide>,
          <Slide className="bg60-b">
            <div className="sub-title">Usai sudah penantiannya selama ini</div>
          </Slide>,
          <Slide className="bg61-b">
            <div className="sub-title">Untuk wanita yang dicinta</div>
          </Slide>,
          <Slide className="bg62-b">
            <div className="sub-title">
              Untuk wanita yang dicinta. Wanita yang dia kagumi selama ini
            </div>
          </Slide>,
          <Slide className="bg63-b">
            <div className="sub-title">
              Rasa bahagia tak terbendung di dalam hatinya
            </div>
          </Slide>,
          <Slide className="bg64-b">
            <div className="sub-title">
              <b>Maka sejak itu, kamu dan dia bersama</b>
            </div>
          </Slide>,
        ]}
      >
        {horizontalNav(
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-4",
            this.state.active["horizontal-slider-4"] - 1
          ),
          changeHorizontalSlide.bind(
            null,
            "horizontal-slider-4",
            this.state.active["horizontal-slider-4"] + 1
          )
        )}
      </HorizontalSlider>,
      <Slide className="slide bg65-b">
        <div id="title">Begitulah pertemuan dia denganmu</div>
      </Slide>,
      <Slide className="slide bg66-b">
        <div id="title">Sejak saat itu hari harinya bahagia denganmu</div>
      </Slide>,
      <Slide className="slide bg67-b">
        <div id="title">
          Bahkan di hari sedihnya pun masih lebih bahagia dibandingkan dengan
          hari tanpamu
        </div>
      </Slide>,
      <Slide className="slide bg68-b">
        <div id="title">Sayang..</div>
      </Slide>,
      <Slide className="slide bg69-b">
        <div id="title">Ada yang berbeda dengan 28 Februari-mu hari ini</div>
      </Slide>,
      <Slide className="slide bg70-b">
        <div id="title">Ada seseorang yang biasa mendoakanmu dalam diam</div>
      </Slide>,
      <Slide className="slide bg71-b">
        <div id="title">
          Namun hari ini dia bisa berdoa bersamamu untuk semua mimpi dan anganmu
        </div>
      </Slide>,
      <Slide className="slide bg72-b">
        <div id="title">Mimpi mimpimu menjadi mimpinya</div>
      </Slide>,
      <Slide className="slide bg73-b">
        <div id="title">Anganmu menjadi angannya</div>
      </Slide>,
      <Slide className="slide bg74-b">
        <div id="title">Bahagiamu menjadi bahagianya</div>
      </Slide>,
      <Slide className="slide bg75-b">
        <div id="title">Dan sedihmu menjadi sedihnya</div>
      </Slide>,
      <Slide className="slide bg76-b">
        <div id="title">Selamat ulang tahun kasih</div>
      </Slide>,
      <Slide className="slide bg77-b">
        <div id="title">
          Semoga semua harapanmu terwujud dengan cara yang terbaik
        </div>
      </Slide>,
      <Slide className="slide bg78-b">
        <div id="title">Dihapuskan sedih dari hidupmu</div>
      </Slide>,
      <Slide className="slide bg79-b">
        <div id="title">
          {" "}
          Diberikan kesehatan dan umur panjang yang bermanfaat
        </div>
      </Slide>,
      <Slide className="slide bg80-b">
        <div id="title">Dicintai orang orang disekitarmu</div>
      </Slide>,
      <Slide className="slide bg81-b">
        <div id="title">Sayang..</div>
      </Slide>,
      <Slide className="slide bg82-b">
        <div id="title">Semoga di tahun ini dia dan kamu menjadi satu</div>
      </Slide>,
      <Slide className="slide bg83-b">
        <div id="title">Mimpinya menjadi satu</div>
      </Slide>,
      <Slide className="slide bg84-b">
        <div id="title">Angannya menjadi satu</div>
      </Slide>,
      <Slide className="slide bg85-b">
        <div id="title">Bahagia dan sedihnya menjadi satu</div>
      </Slide>,
      <Slide className="slide bg86-b">
        <div id="title">Hidupmu dan hidupnya menjadi satu</div>
      </Slide>,
      <Slide className="slide bg87-b">
        <div id="title">Kusampaikan salam dari dia untukmu wahai kasih</div>
      </Slide>,
      <Slide className="slide bg88-b">
        <button
          style={{
            position: "absolute",
            background: "none",
            fontSize: 20,
            top: "10px",
            transform: "translate(-50%, -50%)",
            color: "white",
            opacity: "50%",
            border: "0px",
          }}
          onClick={changeFullpageSlide.bind(null, 0)}
        >
          Back to Top
        </button>
        <div id="title">Dia, adalah aku yang selalu mencintaimu ❤️</div>
      </Slide>,
    ];
    fullPageOptions.slides = verticalSlides;

    return (
      <div>
        <ReactAudioPlayer
          src={BGAudio}
          loop
          controls
          className="audio-player"
        />
        <Fullpage
          onSlideChangeStart={this.onSlideChangeStart}
          onSlideChangeEnd={this.onSlideChangeEnd}
          {...fullPageOptions}
        ></Fullpage>
      </div>
    );
  }
}

function scrollNavStart(nav) {
  nav.style.position = "fixed";
}

function scrollNavEnd(nav) {
  nav.style.position = "absolute";
}

export default FullpageReact;



// WEBPACK FOOTER //
// ./src/app.jsx